import Contact from "@mpa/toolbox/models/Contact";
import type { PartyInfo } from "@mpa/toolbox/models/Party";

import { PromiseToast } from "../../components/async/PromiseToast";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import { callOutgoingRequest } from "../../data/tanstack-query";
import { createContact } from "../../endpoints/outgoing-requests";
import useSubmit from "../../hooks/useSubmit";
import { navigate } from "../../navigation/location";
import { PartyEditor } from "./components/PartyEditor";
import { contactsRoute } from "./navigation";

export default function NewContactPage() {
    const [onEditorDone, edition] = useSubmit(async (infos: PartyInfo[]) => {
        const contact = new Contact();
        contact.infos = infos;
        await callOutgoingRequest(createContact(contact));
        navigate(contactsRoute.getLocation());
    }, []);
    return (
        <LightPageLayout>
            <PromiseToast promise={edition} message="Contact créé" />
            <PageHeader title="Nouveau contact" />
            <PartyEditor infos={[]} onDone={onEditorDone} />
        </LightPageLayout>
    );
}
